<template>
  <div class="ui container">
    <div class="ui left aligned container">
      <div class="ui breadcrumb" v-if="$route.name==='FanInfo'">
        <router-link class="section" to="/mm/stars">明星</router-link>
        <i class="right chevron icon divider"></i>
        <router-link class="section" :to="'/mm/stars/'+user.starid">{{ user.star_name }}</router-link>
        <i class="right chevron icon divider"></i>
        <div class="active section">{{ user.name }}</div>
      </div>
      <div class="ui breadcrumb" v-else>
        <router-link class="section" to="/mm/users">用户</router-link>
        <i class="right chevron icon divider"></i>
        <div class="active section">{{ user.name }}</div>
      </div>
    </div>
    <div class="ui divider"></div>

    <button class="ui small icon refresh button" :class="{disabled: loading}" @click="load">
      <i class="refresh icon"></i>
    </button>

    <div class="ui raised segment">
      <h3>{{ user.name }}</h3>
      <img class="ui avatar image" :src="user.head_img">
      <template v-if="user.starid===YCY">
        <button class="ui bind button" :class="{disabled: user.bind}" v-if="account.isAdmin" @click="bind">
          绑定
        </button>
        <button class="ui bind button" :class="{disabled: user.bind}" v-else @click="applyModal=true">
          申请绑定
        </button>
      </template>
      <div class="ui toggle delegate checkbox" v-if="user.starid===YCY&&cat.mmid&&account.isAdmin">
        <input type="checkbox" v-model="user.delegated" @click="delegate">
        <label>托管</label>
      </div>

      <div class="ui grid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>明星：
            <router-link :to="'/mm/stars/'+user.starid">{{ user.star_name }}</router-link>
          </div>
          <div>喵币： {{ cat.mb_num }}</div>
          <div>本周投币： {{ user.my_this_week_num }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&cat.mmid&&access">
          <button class="ui button" :class="{disabled: cat.mb_num<=0||loading}" @click="num=cat.mb_num;vote=true">
            投币
          </button>
        </div>
        <div class="four wide column"></div>
      </div>

      <div class="ui grid" v-if="cat.mmid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>等级： {{ cat.grade }}</div>
          <div>经验值： {{ cat.growth_num }} / {{ cat.this_grade_max_growth_num }}</div>
          <div>经验排名： {{ cat.growth_sort }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&access">
          <button class="ui negative button" :class="{disabled: cat.growth_num<1||loading}" @click="showExchange">
            兑换
          </button>
        </div>
        <div class="four wide column"></div>
      </div>
    </div>

    <div class="ui raised segment">
      <h3>{{ cat.mm_name }}</h3>
      <div v-if="cat.noexist&&(user.starid===YCY||user.starid==='')&&account.isAdmin">
        <button class="ui button" @click="createCat">养猫</button>
        <div class="ui divider"></div>
        <button class="ui button" :class="{disabled: loading}" @click="helpOther">帮撸喵</button>
      </div>
      <button class="ui all button" :class="{disabled: disabled||loading}" data-tooltip="一键陪伴签到打工pk帮撸" v-if="user.starid===YCY&&cat.mmid&&access" @click="workAll">
        一键任务
      </button>

      <div class="ui grid" v-if="cat.mmid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>逗猫次数： {{ cat.dm_num }} / 5<span v-if="cat.dm_next_ts"> 冷却： {{ cat.dm_next_ts }}</span></div>
          <div>喂喵粮次数： {{ cat.wml_num }} / 5<span v-if="cat.wml_next_ts"> 冷却： {{ cat.wml_next_ts }}</span></div>
          <div>洗澡次数： {{ cat.xz_num }} / 5<span v-if="cat.xz_next_ts"> 冷却： {{ cat.xz_next_ts }}</span></div>
          <div>铲猫砂次数： {{ cat.cms_num }} / 5<span v-if="cat.cms_next_ts"> 冷却： {{ cat.cms_next_ts }}</span></div>
        </div>
        <div class="three wide column" v-if="user.starid===YCY&&access">
          <button class="ui button"
                  :class="{disabled: cat.dm_num+cat.wml_num+cat.xz_num+cat.cms_num===20||cat.dm_next_ts+cat.cms_next_ts+cat.xz_next_ts+cat.wml_next_ts||loading}"
                  @click="feed">
            一键陪伴
          </button>
        </div>
        <div class="four wide column"></div>
      </div>

      <div class="ui grid" v-if="cat.mmid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>
            今日签到： {{ cat.is_sign ? '是' : '否' }}
          </div>
          <div>连续签到天数： {{ cat.sign_day_num }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&access">
          <button class="ui button" :class="{disabled: cat.is_sign||loading}" @click="sign">签到</button>
        </div>
        <div class="four wide column"></div>
      </div>

      <div class="ui grid" v-if="cat.mmid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>PK次数： {{ cat.mm_pk_num }} / 5</div>
          <div>离线PK得分： {{ cat.offline_be_pk_score }}</div>
          <div>离线PK失败： {{ cat.offline_be_pk_lose }}</div>
          <div>离线PK成功： {{ cat.offline_be_pk_win }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&access">
          <button class="ui button" :class="{disabled: cat.mm_pk_num>=5||cat.mb_num<25||loading}" @click="pk">
            猫咪PK
          </button>
        </div>
        <div class="four wide column">经验值比对方高才会PK</div>
      </div>

      <div class="ui grid" v-if="cat.mmid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>观看广告次数： {{ cat.watch_ad_num }} / 10</div>
          <div>打工次数： {{ cat.work_num }} / 10</div>
          <div>完成微博任务： {{ cat.is_wb_task_finish ? '是' : '否' }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&access">
          <button class="ui button" :class="{disabled: cat.watch_ad_num+cat.work_num>=20||loading}" @click="work">
            一键打工
          </button>
        </div>
        <div class="four wide column"></div>
      </div>

      <div class="ui grid" v-if="cat.mmid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>今日兑换步数： {{ cat.today_exchange_step_num }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&access">
          <button class="ui button" :class="{disabled: cat.today_exchange_step_num>=60000||loading}" @click="open=true">
            遛猫
          </button>
        </div>
        <div class="four wide column">可以兑换任意值，超过60000</div>
      </div>
    </div>

    <div class="ui raised segment" v-if="cat.mmid">
      <div class="ui grid">
        <div class="four wide column"></div>
        <div class="four wide column">
          <div>被撸次数： {{ help.helper_num }} / 10</div>
          <div>被撸上限： {{ help.is_reach_be_helped_limit ? '是' : '否' }}</div>
        </div>
        <div class="two wide column" v-if="user.starid===YCY&&access">
          <button class="ui button" :class="{disabled: help.helper_num>=10||loading}" @click="helpCat">找人撸它</button>
          <div class="ui divider"></div>
          <button class="ui button" :class="{disabled: loading}" @click="helpOther">帮撸喵</button>
        </div>
        <div class="four wide column"></div>
      </div>

      <div class="ui grid" v-if="help.helper_num">
        <div class="five wide column"></div>
        <div class="five wide column">
          <div class="ui left aligned container">
            帮撸列表：
            <div v-for="helper in help.helper_list">
              <router-link :to="'/mm/users/'+helper.helper_openid">
                <img class="ui avatar image" :src="helper.helper_head_img">
                {{ helper.helper_name || helper.helper_openid }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="open" title="兑换步数">
      <form class="ui form">
        <div class="required field">
          <label>步数</label>
          <input name="name" type="number" v-model="steps">
        </div>
      </form>
      <template slot="actions">
        <div @click="open=false" class="ui cancel button">取消</div>
        <div @click="feedCatSteps" class="ui positive button" :class="{disabled: steps<=0}">兑换</div>
      </template>
    </Modal>

    <Modal v-model="vote" title="投币">
      <form class="ui form">
        <div class="required field">
          <label>喵币数量</label>
          <input name="name" type="number" v-model="num">
        </div>
      </form>
      <template slot="actions">
        <div @click="vote=false" class="ui cancel button">取消</div>
        <div @click="give" class="ui positive button" :class="{disabled: num<=0}">兑换</div>
      </template>
    </Modal>

    <Modal v-model="modal" title="经验值兑换喵币">
      <form class="ui form">
        <div class="required field">
          <label>经验值</label>
          <input name="name" type="number" v-model="num">
        </div>
      </form>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="exchange" class="ui negative button" :class="{disabled: num<=0}">兑换</div>
      </template>
    </Modal>

    <Modal v-model="applyModal" title="申请绑定">
      <form class="ui form">
        <div class="required field">
          <label>微信号</label>
          <input name="comment" type="text" placeholder="留下你的微信号进行验证" v-model="comment">
        </div>
      </form>
      <template slot="actions">
        <div @click="applyModal=false" class="ui cancel button">取消</div>
        <div @click="apply" class="ui positive button" :class="{disabled: !comment}">申请</div>
      </template>
    </Modal>

  </div>
</template>

<script>
import axios from 'axios'
import auth from '../../services/Auth';
import Modal from '@/components/Modal'
import EventBus from '@/services/event-bus'

export default {
  name: 'UserInfo',
  components: {
    Modal
  },
  data () {
    return {
      id: '',
      comment: '',
      YCY: '5644764907',
      loading: false,
      open: false,
      vote: false,
      modal: false,
      applyModal: false,
      num: 0,
      handle: 0,
      steps: 2000,
      account: {},
      user: {},
      cat: {},
      help: {},
    }
  },
  watch: {
    '$route' (to) {
      this.id = to.params.id
      this.load()
    }
  },
  computed: {
    disabled () {
      const pb = (this.cat.dm_num + this.cat.wml_num + this.cat.xz_num + this.cat.cms_num) === 20
      const time = this.cat.dm_next_ts + this.cat.cms_next_ts + this.cat.xz_next_ts + this.cat.wml_next_ts
      const pk = this.cat.mm_pk_num>=5||this.cat.mb_num<25
      const ad = this.cat.watch_ad_num+this.cat.work_num>=20
      return (pb || time) && this.cat.is_sign && pk && ad
    },
    access () {
      return this.account.isAdmin || (this.user.owner && this.account.name === this.user.owner.username)
    },
  },
  mounted () {
    this.id = this.$route.params.id
    this.account = auth.user;
    EventBus.$on('login', (data) => {
      this.account = data;
    });
    this.load()
  },
  destroyed () {
    clearInterval(this.handle)
  },
  methods: {
    load () {
      this.loadUser()
      this.loadCat()
      this.loadHelp()
    },
    loadUser () {
      this.loading = true
      axios.get('/mm/users/' + this.id).then(({ data }) => {
        this.loading = false
        this.user = data.data
        if (data.status) {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    loadCat () {
      this.loading = true
      clearInterval(this.handle)
      axios.get('/mm/users/' + this.id + '/cat').then(({ data }) => {
        this.loading = false
        this.cat = data.data
        if (data.status) {
          this.cat = { noexist: true }
          this.$toasted.error(data.message)
          return
        }
        if (this.cat.dm_next_ts || this.cat.cms_next_ts || this.cat.xz_next_ts || this.cat.wml_next_ts) {
          this.handle = setInterval(() => {
            if (this.cat.dm_next_ts) { this.cat.dm_next_ts-- }
            if (this.cat.cms_next_ts) { this.cat.cms_next_ts-- }
            if (this.cat.xz_next_ts) { this.cat.xz_next_ts-- }
            if (this.cat.wml_next_ts) { this.cat.wml_next_ts-- }
            if (this.cat.dm_next_ts + this.cat.cms_next_ts + this.cat.xz_next_ts + this.cat.wml_next_ts === 0) {
              clearInterval(this.handle)
            }
          }, 1000)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    loadHelp () {
      this.loading = true
      axios.get('/mm/users/' + this.id + '/help').then(({ data }) => {
        this.loading = false
        this.help = data.data
        if (data.status) {
          this.$toasted.error(data.message)
          return
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    bind () {
      axios.post('/admin/mm/bind?openid=' + this.id).then(() => {
        this.user.bind = true
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    apply () {
      if (!this.comment) {
        return
      }
      axios.post('/mm/apply', {openid: this.id, comment: this.comment}).then(() => {
        this.$toasted.success('申请成功，等待管理员批准')
        this.user.bind = true
        this.applyModal = false
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    delegate () {
      axios.post('/admin/mm/delegate?openid=' + this.id).then(({data}) => {
        this.user.delegated = data
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    createCat () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/cat').then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.load()
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    pk () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/pk').then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.cat.mm_pk_num++
          this.cat.mb_num += data.data.length * 5
          this.user.mb_num += data.data.length * 5
          this.$toasted.success('PK成功了' + data.data.length + '次')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    feedCatSteps () {
      if (this.steps < 200) {
        this.$toasted.error('步数至少为200！')
        return
      }
      this.loading = true
      axios.post('/mm/users/' + this.id + '/steps?num=' + this.steps / 200 * 200).then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.$toasted.success('兑换步数成功')
          this.open = false
          this.cat.mb_num = data.data.mb_num
          this.user.mb_num = data.data.mb_num
          this.cat.today_exchange_step_num = data.data.today_exchange_step_num
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    helpCat () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/help').then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.loadHelp()
          this.cat.growth_num += data.data.length * 2
          this.cat.mb_num += data.data.length * 5
          this.user.mb_num += data.data.length * 5
          this.$toasted.success('被撸成功了' + data.data.length + '次')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    helpOther () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/helpOther').then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.cat.mb_num += data.data.length * 5
          this.user.mb_num += data.data.length * 5
          this.$toasted.success('帮撸喵成功了' + data.data.length + '次')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    give () {
      if (this.num > this.cat.mb_num) {
        this.$toasted.error('不能超过拥有的喵币数量！')
        return
      }
      this.loading = true
      axios.post('/mm/users/' + this.id + '/give?num=' + this.num).then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.$toasted.success('投币成功')
          this.vote = false
          this.cat.mb_num = data.data.user_mb_num
          this.user.mb_num = data.data.user_mb_num
          this.user.my_this_week_num = data.data.my_this_week_num
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    showExchange () {
      this.num = Math.floor(this.cat.growth_num / 2)
      this.modal = true
    },
    exchange () {
      if (this.num > this.cat.growth_num) {
        this.$toasted.error('不能超过全部经验值！')
        return
      }
      this.loading = true
      axios.post('/mm/users/' + this.id + '/exchange?num=' + this.num).then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.$toasted.success('兑换成功')
          this.modal = false
          this.cat.growth_num = data.data.growth_num
          this.user.mb_num = data.data.mm_num
          this.cat.mb_num = data.data.mm_num
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    sign () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/sign').then(({ data }) => {
        this.loading = false
        if (data.status === 0 && data.data.get_mb_num) {
          this.cat.is_sign = 1
          this.cat.sign_day_num = data.data.sign_day_num
          this.cat.mb_num += data.data.get_mb_num
          this.cat.growth_num += data.data.get_growth_num
          this.$toasted.success('签到成功')
        } else {
          this.$toasted.error(data.message || '签到失败')
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    feed () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/feed').then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.loadCat()
          const count = data.data.filter(e => e.status === 0).length
          this.$toasted.success('陪伴了' + count + '次')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    work () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/work').then(({ data }) => {
        this.loading = false
        if (data.status === 0) {
          this.loadCat()
          this.$toasted.success('工作了' + data.data.length + '次')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
    workAll () {
      this.loading = true
      axios.post('/mm/users/' + this.id + '/all').then(() => {
        this.loading = false
        this.load()
        this.$toasted.success('一键任务完成')
      }, (err) => {
        this.$toasted.error(err.message)
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>
.ui.grid>.column:not(.row) {
  padding-top: 6px;
  padding-bottom: 6px;
}

.column .ui.divider {
  margin-top: 3px;
  margin-bottom: 3px;
}

.refresh.button {
  float: right;
  margin-top: -48px;
}

.bind.button {
  position: absolute;
  top: 12px;
  right: 12px;
}

.delegate.checkbox {
  position: absolute;
  top: 60px;
  right: 12px;
}

.all.button {
  position: absolute;
  top: 12px;
  right: 12px;
}
</style>
